import React from 'react';

const ValidationMessage = ({ message, color }) => {
  return (
    <div style={{ display: 'flex', flexFlow: 'row-reverse' }}>
      <span style={{ color }}>{message}</span>
    </div>
  );
};

export default ValidationMessage;
